module.exports = __webpack_public_path__ + "media/images/tags-dbf23bc89126860945bf7e0cd829a448.svg";